import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import DvsEvaluationService, {
  TestForEvaluation,
} from "../../_services/DvsEvaluationService";
import "./dvs-evaluation.css";

const DvsEvaluationSearch: React.FC = () => {
  const [tests, setTests] = useState<TestForEvaluation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const history = useHistory();

  useEffect(() => {
    fetchTests();
  }, []);

  const fetchTests = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await DvsEvaluationService.getTestsForEvaluation();
      setTests(data);
    } catch (err: any) {
      setError(err?.message || "Failed to load tests");
    } finally {
      setLoading(false);
    }
  };

  const handleStartEvaluation = (testId: number, evaluatorType: number) => {
    history.push(`/dvs-evaluation/${testId}?evaluatorType=${evaluatorType}`);
  };

  return (
    <div className="dvs-eval-root dvs-list-root">
      <h4 className="dvs-eval-page-title">Digital Evaluation</h4>
      <p className="dvs-eval-page-subtitle">
        Tests assigned for evaluation. Pick one to start grading student responses.
      </p>

      {loading && (
        <div className="dvs-list-loading">
          <Spinner role="status" animation="border" variant="primary" />
          <p>Loading assigned tests…</p>
        </div>
      )}

      {error && <div className="dvs-list-error">{error}</div>}

      {!loading && !error && tests.length === 0 && (
        <div className="dvs-list-empty">
          No tests assigned for evaluation.
        </div>
      )}

      {!loading && tests.length > 0 && (
        <div className="dvs-list-card">
          <table className="dvs-list-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Test</th>
                <th>Evaluator</th>
                <th>Allocated</th>
                <th>Pending</th>
                <th>Evaluated</th>
                <th>Reported</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {tests.map((t, idx) => (
                <tr key={`${t.testId}-${t.evaluatorType}`}>
                  <td>{idx + 1}</td>
                  <td>
                    <span className="dvs-list-test-name">{t.testName}</span>
                    <span className="dvs-list-test-id">#{t.testId}</span>
                  </td>
                  <td>
                    <span className="dvs-list-evaluator">Evaluator {t.evaluatorType}</span>
                  </td>
                  <td>
                    <span className="dvs-list-count dvs-list-count--allocated">{t.assigned}</span>
                  </td>
                  <td>
                    <span className="dvs-list-count dvs-list-count--pending">{t.pending}</span>
                  </td>
                  <td>
                    <span className="dvs-list-count dvs-list-count--evaluated">{t.evaluated}</span>
                  </td>
                  <td>
                    <span
                      className={`dvs-list-count ${
                        t.reported > 0
                          ? "dvs-list-count--reported-some"
                          : "dvs-list-count--reported-zero"
                      }`}
                    >
                      {t.reported}
                    </span>
                  </td>
                  <td>
                    {t.pending > 0 ? (
                      <button
                        className="dvs-list-action-btn"
                        onClick={() =>
                          handleStartEvaluation(t.testId, t.evaluatorType)
                        }
                      >
                        Start Evaluation →
                      </button>
                    ) : (
                      <span className="dvs-list-completed-tag">✓ Completed</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DvsEvaluationSearch;
